export default __webpack_public_path__ + "locales/sr-Latn-RS/JavascriptSdk.json?hash=a3dd486836ba998441b926d91ba5d727";